import { ChevronDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import type { ProfileGroup } from "../data/profile";

export function GroupsPicker({
    id,
    items,
    value,
    onChange,
}: {
    id: string;
    items: ProfileGroup[];
    value: string[];
    onChange: (groupIds: string[]) => void;
}) {
    const selected = items.filter((group) => value.includes(group.id));
    const summary = selected.length
        ? selected.map((group) => group.name).join(", ")
        : "None";

    return (
        <Popover>
            <PopoverTrigger
                render={
                    <Button
                        id={id}
                        type="button"
                        variant="outline"
                        className="h-9 w-full justify-between rounded-md px-3 font-normal text-xs"
                    />
                }
            >
                <span className="min-w-0 truncate">{summary}</span>
                <ChevronDown className="size-4 text-zinc-400" />
            </PopoverTrigger>
            <PopoverContent align="start" className="w-64 p-1">
                {items.map((group) => {
                    const checked = value.includes(group.id);
                    return (
                        <button
                            key={group.id}
                            type="button"
                            className="flex w-full cursor-pointer items-center gap-2 rounded-md px-2 py-1.5 text-left text-xs text-zinc-900"
                            onClick={() => {
                                onChange(
                                    checked
                                        ? value.filter((id) => id !== group.id)
                                        : [...value, group.id],
                                );
                            }}
                        >
                            <Checkbox
                                checked={checked}
                                className="pointer-events-none"
                            />
                            {group.name}
                        </button>
                    );
                })}
            </PopoverContent>
        </Popover>
    );
}
